import { Grid } from 'antd'

const { useBreakpoint } = Grid

/** md (≥768px) 以下为移动端 */
export function useIsMobile(): boolean {
  const screens = useBreakpoint()
  return !screens.md
}

export function useIsTablet(): boolean {
  const screens = useBreakpoint()
  return !!screens.md && !screens.lg
}

export default useBreakpoint
